import { FETCH_COUPON_DATA_FAILED, FETCH_COUPON_DATA_REQUEST, FETCH_COUPON_DATA_SUCCESS } from './actionCreator';

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const couponsReducers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COUPON_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_COUPON_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case FETCH_COUPON_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default couponsReducers;
